import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { ButtonComponent } from '@mds/ui';

import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-add-url-dialog',
  standalone: true,
  templateUrl: './add-url-dialog.component.html',
  styleUrls: ['./add-url-dialog.component.scss'],
  imports: [
    MatDialogModule,
    MatIconModule,
    ButtonComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
]
})
export class AddUrlDialogComponent implements OnInit {
  urlForm: any;
  constructor(
    public dialogRef: MatDialogRef<AddUrlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddUrlDialogComponent
  ) {
    this.createFrom(data);
  }

  onInit() {}

  ngOnInit(): void {}

  createFrom(data) {
    this.urlForm = new UntypedFormGroup({
      url: new UntypedFormControl(data.url)
    });
  }

  closedialog() {
    this.dialogRef.close(this.urlForm.value);
  }

  createFile() {
    this.dialogRef.close(this.urlForm);
  }
}
